import * as Popover from "@radix-ui/react-popover";
import { ReactNode } from "react";
import { cn } from "../../../utils/classes";
import railStyles from "../nav-rail/nav-rail.module.css";
import styles from "./app-launcher.module.css";

export type AppLauncherItem = {
  label: string;
  href: string;
  icon?: ReactNode;
  active?: boolean;
};

export type AppLauncherProps = {
  items: readonly AppLauncherItem[];
  expanded?: boolean;
  className?: string;
};

/** Bottom-of-rail application switcher with real links for native browser behaviour. */
export function AppLauncher({
  items,
  expanded = false,
  className,
}: AppLauncherProps) {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button
          type="button"
          className={cn(
            railStyles.item,
            styles.trigger,
            !expanded && styles.triggerCollapsed,
            className,
          )}
          aria-label="Open app launcher"
          title="Apps"
        >
          <span className={railStyles.itemIconBox}>
            <span className={styles.waffleIcon} aria-hidden="true">
              {Array.from({ length: 9 }, (_, index) => (
                <span key={index} />
              ))}
            </span>
          </span>
          {expanded && <span className={railStyles.itemLabel}>Apps</span>}
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          side="right"
          align="end"
          sideOffset={8}
          className={styles.content}
        >
          <ul className={styles.list}>
            {items.map((item) => {
              const tileContent = (
                <>
                  <span className={styles.appIcon}>{item.icon}</span>
                  <span className={styles.appLabel}>{item.label}</span>
                </>
              );

              return (
                <li key={`${item.label}:${item.href}`}>
                  <Popover.Close asChild>
                    {item.active ? (
                      <button
                        type="button"
                        className={cn(styles.appLink, styles.appLinkActive)}
                        aria-current="page"
                      >
                        {tileContent}
                      </button>
                    ) : (
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.appLink}
                      >
                        {tileContent}
                      </a>
                    )}
                  </Popover.Close>
                </li>
              );
            })}
          </ul>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
